import { render, staticRenderFns } from "./multiple-brand-toggle.vue?vue&type=template&id=f4239568&scoped=true"
import script from "./multiple-brand-toggle.vue?vue&type=script&lang=js"
export * from "./multiple-brand-toggle.vue?vue&type=script&lang=js"
import style0 from "./multiple-brand-toggle.vue?vue&type=style&index=0&id=f4239568&prod&lang=css"
import style1 from "./multiple-brand-toggle.vue?vue&type=style&index=1&id=f4239568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4239568",
  null
  
)

export default component.exports